






import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import { Base, App } from '@/views/vocabulary/game/common/base';
import createjs from 'createjs-npm';
import { config } from './config.js';
import loading from './loading.vue';
import game from './game.vue';

@Component({
  components: {
    loading,
    game,
  },
})
export default class extends Vue {
    @Getter public getGameLoading: any;

    @Getter public getDataLoading: any;

    private app: any;

    defaultHeight: ''

    private created() {
    }

    private mounted() {
      // this.defaultHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      // const appDom = document.getElementById('app')
      // appDom.style.height = this.defaultHeight + 'px'
    }
}
